// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateShowMoreGroupsVisibility = (state, action) => action.isMoreSummaryVisible;

export default (state = getDefaultState().isMoreSummaryVisible, action) => {

    const actionTypes = {
        [actions.UPDATE_SHOW_MORE_GROUPS_VISIBILITY]: updateShowMoreGroupsVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/labor-additive/reducers/show-more-groups-visibility.js